import { color as colorVar, cx, fontSize, fontWeight, lineHeight, type ColorToken, type FontToken, type WeightToken } from "./tokens.ts";
import "./columns.css";

export type TruncatedTextProps = {
  variant?: FontToken;
  weight?: WeightToken;
  color?: ColorToken;
  /**
   * "end" (default): one line with a trailing ellipsis, the full text as a tooltip (titles, file names in headers).
   * "words": every line, wrapping between words (a long word breaks only when it alone is wider than the line).
   */
  mode?: "end" | "words";
  align?: "start" | "center";
  testID?: string;
  children: string;
};

/**
 * Text for user content of any length (file and page names). Native: `Text.lineLimit(1).truncationMode(.middle)`
 * + `.help()` (iOS), `maxLines = 1, overflow = Ellipsis` + a tooltip (Android).
 */
export function TruncatedText({ variant = "body", weight, color = "text.primary", mode = "end", align = "start", testID, children }: TruncatedTextProps) {
  return (
    <span
      className={cx("b-text", mode === "end" ? "b-truncate" : "b-wrap-words")}
      title={mode === "end" ? children : undefined}
      data-testid={testID}
      style={{ fontSize: fontSize(variant), lineHeight: lineHeight(variant), fontWeight: weight === undefined ? undefined : fontWeight(weight), color: colorVar(color), textAlign: align === "center" ? "center" : undefined }}
    >
      {children}
    </span>
  );
}
